import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import CodeEditorIndex from './components/code-editor/CodeEditorIndex';
import CollabEditorIndex from './components/code-editor/CollabEditorIndex';
import styles from './App.module.css';
import Home from './components/home/Home';
import setAuthToken from './utils/setAuthToken';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HostedInterview from './components/hosted-interview/HostedInterview';
import { fetchUser, logoutUser } from './actions/user';
import { useDispatch } from 'react-redux';
import Login from './components/login/Login';
import NotFound from './components/not-found/NotFound';

if (localStorage.getItem('codex_token')) {
  setAuthToken(localStorage.getItem('codex_token'));
}

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchUserUtil();
    //logoutUser();
  }, []);

  const fetchUserUtil = async () => {
    const res = await fetchUser();
    dispatch(res);
  };
  return (
    <Router>
      <div className={styles.App}>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path={['/ide']} component={CodeEditorIndex} />
          <Route
            exact
            path={['/interview/:id']}
            render={props => <CollabEditorIndex {...props} />}
          />
          <Route path='/hosted-interviews' component={HostedInterview} />
          <Route path='/login' component={Login} />
          <Route path='/404' component={NotFound} />
          <Redirect to='/404' />
        </Switch>
        <ToastContainer position={'bottom-right'} />
      </div>
    </Router>
  );
};

export default App;
